import React, { FC, memo } from 'react';
import dynamic from 'next/dynamic';

const Feature = dynamic(() => import('./feature'), { ssr: false });
const Guide = dynamic(() => import('./guide'), { ssr: false });
const Slogan = dynamic(() => import('./slogan'), { ssr: false });

const Landing: FC = () => {
  return (
    <div className="mt-4">
      {/* <hr /> */}
      <Feature />
      <div className="mb-4" />
      {/* <hr /> */}
      <Guide />
      {/* <hr />
      <Slogan /> */}
    </div>
  );
};

export default memo(Landing);
